import Customers from "./Customers.jsx";

export default Customers;
